import React from "react";
import './video-list.scss';
import { getImageSource } from "../../utility/image-source";
import { ImageConstants } from "../../constants/constants";
import CwContentViewer from "../common/cw-content-viewer/cw-content-viewer";
import SchoolApi from '../../apis/school';
import PaginationComponent from "../common/cw-pagination/cw-pagination-v2";
import ReactTooltip from 'react-tooltip';
import VideoDetail from "./video-detail/video-detail";
import Dropdown from '../common/dropdown-v2/dropdown';
import MasterDataApi from "../../apis/master-data";
import CouponPI from "../../apis/coupons";
import Loading from "../common/loading/loading";
import ChapterListFilter from "./chapter-list-filter/chapter-list-filter";
import ToasterComponent from "../common/cw-toaster-component/cw-toaster-component";
import { Modal, ModalBody } from "reactstrap";
import NotificationModel from '../learning-resources/notification/notification';

class VideoList extends React.Component {



    currentPage = 1
    limit = 10
    filter = {}

    alphabetHash = {}

    state = {
        reloadDropdown: false,
        showAssessmentFilterModal: false,
        selectedMasterDataId: '5e71c0afe6a6150727ddc842',
        showDropdown: false,
        dropDownList: [],
        conceptsInfo: [],
        selectedConceptInfo: [],
        showVideoDetail: false,
        videoInfo: {},
        selectedConceptIndex: -1,
        selectedVideoIndex: -1,
        chapterIntroductionVideo: [],
        boardsDropdownItems: [],
        comprehensionKeywordList: [
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // }
        ],
        search: '',
        seletedAlphabet: "",
        selectedAlphabetIndex: -1,
        showKeywordDetailScreen: false,
        selectedKeyword: "",
        selectedKeywordIndex: -1,
        selectedClass: "",
        isLoading: false
    }

    constructor(props) {
        super(props)

    }


    componentDidMount() {
        this.getClasses()
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                console.log(school)
                let classes = [], boards = [], classNames = [];

                for (let i = 0; i < school.classes.length; i++) {
                    if (['Class 6', 'Class 7', 'Class 8', 'Class 9'].includes(school.classes[i].name)) {
                        classes.push({
                            title: school.classes[i].name,
                            value: school.classes[i].name,
                        })
                    }
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }


                let board = ''
                if (boards.length) {
                    board = boards[0].value
                }


                classNames = classes.map(c => c.value)

                // if (!this.props.delegate?.props?.location?.state) {
                //     this.getSections({ board, class: classNames })
                // }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }

                console.log(classes)

                this.setState({ classDropdownItems: classes, boards, classes }, () => {
                    this.reloadDropdown()
                    this.getAllClassVideoContent({})
                    this.getChapters({})
                })
            }).catch(err => {
                console.log(err)
            })
    }

    getAllClassVideoContent(payload) {

        // if (!payload.class) {
        //     payload.class = "Class 6"
        // }

        this.setState({ isLoading: true })

        if (!this.state.selectedBoard) {
            payload.board = "CBSE"
        } else {
            payload.board = "CBSE"
        }


        MasterDataApi.getAllClassVideoContent(payload).then(allVideosData => {
            console.log(allVideosData)

            this.setState({
                conceptsInfo: allVideosData.chapter,
                chapterIntroductionVideo: allVideosData.chapterIntrodutionVideoLearningContent,
                allClassVideoContent: allVideosData.allClassVideoContent,
                allChapterIntroVideos: allVideosData.allChapterIntroVideos,
                isLoading: false
            })

        }).catch(err => {
            this.setState({ isLoading: false })
            console.log(err)
        })
    }

    getChapters(payload = {}) {

        console.log(payload)

        this.setState({ selectedClass: this.state.selectedClass })

        // if (!payload.class) payload.class = this.state.selectedClass
        // if (!payload.board) payload.board = this.state.selectedBoard

        if (!this.state.selectedBoard && !this.state.selectedClass) {
            // this.setState({ selectedBoard: this.state.boardsDropdownItems[0].value })
            payload.board = "CBSE"
        } else {
            payload.class = this.state.selectedClass
            payload.board = "CBSE"
        }

        MasterDataApi.getAllClassChapterList(payload)
            .then(response => {
                let chapters = [], concepts = []
                response = response.data
                console.log(response)
                // this.setState({ masterDataId: response._id })

                for (let i = 0; i < response.length; i++) {
                    for (let j = 0; j < response[i].chapters.length; j++) {
                        let chapter = response[i].chapters[j]
                        chapters.push({
                            title: chapter.title,
                            value: chapter.key,
                            displayTitle: chapter.title,
                            chapterImageURL: chapter.imageUrl,
                            class: response[i].class,
                            masterDataId: response[i]._id
                        })

                        for (let k = 0; k < chapter.concepts?.length; k++) {
                            let concept = chapter.concepts[k]
                            concepts.push({
                                title: concept.title,
                                displayTitle: concept.title,
                                value: concept.key,
                                chapterKey: chapter.key,
                                chapterTitle: chapter.title,
                                masterDataId: response[i]._id,
                                order: j + 1
                            })
                            // this.buildElosDropdown(concept)
                        }

                        // this.conceptHash[chapter.key] = concepts
                    }
                }

                // chapters.push({value:'ALL',title:'ALL'})
                // console.log(chapters)
                // console.log(concepts)

                let masterDataHash = {}

                chapters.forEach(chapter => {

                    if (!masterDataHash[chapter.masterDataId]) {
                        masterDataHash[chapter.masterDataId] = [chapter]
                    } else {
                        masterDataHash[chapter.masterDataId].push(chapter)
                    }

                })

                console.log(masterDataHash)

                this.setState({
                    chapterList: chapters,
                    orginalChapterList: chapters,
                    selectedChapter: "",
                    conceptsList: concepts,
                    orginalConceptsList: concepts,
                    masterDataHash,
                    selectedMasterDataId: response[0]._id
                })
                this.reloadDropdown()
            }).catch(err => {

                if (err.response && err.response.status === 400) {
                    this.setState({ chapterList: [] })
                }
            })
    }


    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    onSelectDropDown = (option, key, cb) => {
        console.log(option)
        this.setState({ [key]: option?.value, [`${key}Object`]: option, reloadDropdown: true }, () => {

            this.setState({ reloadDropdown: false })

            if (cb) cb()
            if (key == "selectedClass" || key == "selectedBoard") {
                console.log(this.state.selectedBoard)
                // this.getSections()

                let payload = {}

                if (this.state.selectedClass) {
                    payload.class = this.state.selectedClass
                }
                this.getAllClassVideoContent(payload)
                this.getChapters({})
            }
        })
    }




    videoEnded(chapterKey, chapterTitle, content, subType, type) {

        console.log(content)

        if (this.watchedVideoRewardAddedList[`${chapterKey}_${content._id}`]) {
            // console.log('returned')
            return;
        }

        let payload = {
            type: type,
            subType: subType,
            chapterKey,
            chapterTitle: this.state.chapterTitle,
            contentTitle: chapterTitle,
            contentId: content._id,
            board: this.state.selectedBoard,
            class: this.state.selectedClass
        }

        CouponPI.addVideoWatchedRewardPoint(payload).then((res) => {
            if (res.data.rewardPointAdded && res.data.chapterKey) {
                this.watchedVideoRewardAddedList[`${res.data.chapterKey}`] = true
            }

            if (type === "CASE_STUDY_ASSIGN" || type === "CHAPTER_ACTIVITY_ASSIGN") {
                this.setState({ rewardAssigned: this.watchedVideoRewardAddedList })
            }

            this.setState({})
        }).catch(err => {
            console.log(err)
        })


    }

    updateTimePlayed(videoRef, videoPositionIndexInDescription, index) {
        console.log(videoRef)
        if (videoRef.current) {
            const currentTime = Math.floor(videoRef.current.currentTime);
            console.log('success', currentTime)
            //   this.setState({ secondsPlayed: currentTime });
        }
    };


    progress(e) {
        console.log(e.time)
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.currentPage = selectedPage
        this.onPageSelected(selectedPage, startIndex)
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage })
        this.getComprehensionKeywords(this.filter, this.filter)
    }

    onChangeHandler(event, key) {
        let value = event.target.value
        this.setState({ [key]: value })
        this.changeChapterList(value)
    }

    changeChapterList(searchText) {
        // console.log(searchText)
        let orginalChapterList = this.state.orginalChapterList
        let orginalConceptsList = this.state.orginalConceptsList
        let orginalAllClassVideoContent = this.state.allClassVideoContent
        let orginalllChapterIntroVideos = this.state.allChapterIntroVideos

        let allVideosList = [...orginalChapterList, ...orginalConceptsList, ...orginalAllClassVideoContent, ...orginalllChapterIntroVideos]

        let value = searchText
        // console.log(orginalChapterList)
        // console.log('1')
        if (value && value.length >= 2) {
            let chapterList = orginalChapterList.filter(option => option[`title`].toLowerCase().startsWith(value.toLowerCase()));
            console.log(chapterList)
            // let chapterKeys = chapterList.map(chapter => `${chapter.masterDataId}_${chapter.value}`)
            // // console.log(chapterKeys)
            // let conceptsList = orginalConceptsList.filter(option => option[`title`].toLowerCase().startsWith(value.toLowerCase()));
            // console.log(conceptsList)
            // let conceptKeys = conceptsList.map(concept => `${concept.masterDataId}_${concept.value}`)
            // // console.log(conceptKeys)
            // let contentsArray = orginalAllClassVideoContent.filter(content => content[`displayTitle`].toLowerCase().startsWith(value.toLowerCase()));
            // console.log(contentsArray)
            // let contentIds = contentsArray.map(content => content.masterDataId_EloId_ContentIdMapping)
            // // console.log(contentIds)
            // let introContentsArray = orginalllChapterIntroVideos.filter(content => content[`displayTitle`].toLowerCase().startsWith(value.toLowerCase()));
            // console.log(introContentsArray)
            // let introContentIds = introContentsArray.map(content => content.masterDataId_ChapterKey_ContentIdMapping)
            // console.log(introContentIds)

            // this.getAllClassVideoContent({
            //     chapterKey: chapterKeys,
            //     class: this.state.selectedClass,
            //     conceptKeys: conceptKeys, contentIds: contentIds, introContentIds
            // })

            // let filteredVideoList = allVideosList.filter(option => option[`title`].toLowerCase().startsWith(value.toLowerCase()))
            let filteredVideoList = allVideosList.filter(option => option[`title`].toLowerCase().includes(value.toLowerCase()))


            let dropDownList = []

            filteredVideoList.forEach(item => {
                let existInDropDown = dropDownList.filter(listItem => listItem.displayTitle === item.displayTitle)
                if (!existInDropDown.length) {
                    dropDownList.push(item)
                }
            })
            this.setState({ chapterList: chapterList, dropDownList: dropDownList, showDropdown: true });
        }

        if (value === '') {
            this.getAllClassVideoContent({})
            this.setState({ chapterList: orginalChapterList, showDropdown: false });
        }
    }

    onSelectCode(item) {
        this.setState({ search: item.displayTitle, showDropdown: false }, () => {
            // this.setState({ isLoginEnable: this.validateMobile(this.state.mobileNumber) })
        })

        this.showSelectedContent(item.displayTitle)
    }

    showSelectedContent(searchText) {
        // console.log(searchText)
        let orginalChapterList = this.state.orginalChapterList
        let orginalConceptsList = this.state.orginalConceptsList
        let orginalAllClassVideoContent = this.state.allClassVideoContent
        let orginalllChapterIntroVideos = this.state.allChapterIntroVideos

        let value = searchText

        let chapterList = orginalChapterList.filter(option => option[`title`].toLowerCase().includes(value.toLowerCase()));
        // console.log(chapterList)
        let chapterKeys = chapterList.map(chapter => `${chapter.masterDataId}_${chapter.value}`)
        // console.log(chapterKeys)
        let conceptsList = orginalConceptsList.filter(option => option[`title`].toLowerCase().includes(value.toLowerCase()));
        // console.log(conceptsList)
        let conceptKeys = conceptsList.map(concept => `${concept.masterDataId}_${concept.value}`)
        // console.log(conceptKeys)
        let contentsArray = orginalAllClassVideoContent.filter(content => content[`displayTitle`].toLowerCase().includes(value.toLowerCase()));
        // console.log(contentsArray)
        let contentIds = contentsArray.map(content => content.masterDataId_EloId_ContentIdMapping)
        // console.log(contentIds)
        let introContentsArray = orginalllChapterIntroVideos.filter(content => content[`displayTitle`].toLowerCase().includes(value.toLowerCase()));
        // console.log(introContentsArray)
        let introContentIds = introContentsArray.map(content => content.masterDataId_ChapterKey_ContentIdMapping)
        // console.log(introContentIds)

        this.getAllClassVideoContent({
            chapterKey: chapterKeys,
            class: this.state.selectedClass,
            conceptKeys: conceptKeys, contentIds: contentIds, introContentIds
        })
        this.setState({ chapterList: chapterList });

    }



    clearFilter = () => {

        this.setState({
            search: "",
            selectedClass: "",
            selectedBoard: '',
            selectedAlphabetIndex: -1,
            reloadDropdown: true

        }, () => {
            this.setState({ reloadDropdown: false })
            this.onFilterGo()
        })

    }

    onFilterGo() {
        let payload = {}
        if (this.state.search) {
            payload.search = this.state.search
        }

        this.getAllClassVideoContent(payload)

    }

    getAlphabets() {
        let alphabets = []

        for (let i = 65; i <= 90; i++) {

            let character = ""

            if (this.alphabetHash[String.fromCharCode(i)]) {
                character = <div className={`alphabet-wrapper text-center cursor-pointer
             ${this.state.selectedAlphabetIndex === i ? "selected-alphabet-bg" : ""}`}
                    onClick={() => this.setAlphabet(i)}
                >{String.fromCharCode(i)}</div>
            } else {
                character = <div className={`alphabet-wrapper text-center disabled-alphabet
                `}
                >{String.fromCharCode(i)}</div>
            }





            alphabets.push(character)
        }

        return alphabets;
    }

    setAlphabet(index) {
        this.alphabetSearch(String.fromCharCode(index))
        this.setState({ selectedAlphabetIndex: index })
    }

    alphabetSearch(alphabet) {

        let payload = {}
        if (alphabet) {
            payload.alphabetSearch = alphabet
        }

        console.log(payload)

        this.getComprehensionKeywords(payload, this.filter)
    }

    showKeywordDetail(keyword, index) {
        this.setState({ showKeywordDetailScreen: true, selectedKeyword: keyword, selectedKeywordIndex: index })
    }

    hideVideoDetailScreen() {
        let id = this.state.videoInfo._id
        this.setState({ showVideoDetail: false, videoInfo: {} }, () => {
            const element = document.getElementById(id);
            // console.log(id, element)
            element.scrollIntoView({ behavior: "instant", block: 'center' })

        })
    }


    showVideoDetail(concept, videoContent, conceptIndex, videoIndex, introVideo) {

        let videoInfo = {
            ...videoContent,
            conceptTitle: introVideo ? "Chapter Introduction Video" : concept.title,
            chapterTitle: concept.chapterTitle,
            chapterImageUrl: concept.chapterImageUrl,
            class: concept.class,
            conceptKey: concept.conceptKey ? concept.conceptKey : null,
            chapterKey: concept.chapterKey,
            contentDisplayTitle: videoContent.displayTitle,
            contentId: videoContent._id,
            isChapterIntro: introVideo
        }

        this.setState({ showVideoDetail: true, videoInfo, selectedConceptIndex: conceptIndex, selectedVideoIndex: videoIndex })
    }


    onApplyFilter = (filterPayload) => {

        this.page = 1;

        this.payload = {}

        this.selectedFilters = filterPayload;

        console.log(filterPayload)

        this.setState({ selectedMasterDataId: filterPayload.selectedMasterDataId })

        // if (filterPayload.filterType == 'CHAPTERS') {

        let chapterKeys = filterPayload.selectedItems.map(item => `${item.masterDataId}_${item.value}`)

        this.payload['chapterKey'] = chapterKeys.join(',');

        this.hideAssessmentFilterModal(() => {
            // setTimeout(() => {
            this.getAllClassVideoContent({ chapterKey: chapterKeys })
            // }, 100);

        })
        // }



        if (filterPayload.selectedItems.length > 0) {

            this.setState({ showActiveFilter: true })

        } else {

            this.setState({ showActiveFilter: false })
        }


    }

    goBack = () => {
        this.props.navigation.navigate('LateralMenu')
    }

    showAssessmentFilterModal = () => {
        this.setState({ showAssessmentFilterModal: true })
    }

    hideAssessmentFilterModal = (callback) => {
        this.setState({ showAssessmentFilterModal: false }, () => {
            callback && callback()
        })
    }



    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb '>
                <span className="bread-crumb-title" onClick={this.goToChapterListScreen}>{`${this.props.selectedClass || ""} >`}</span>
                <span className='pl-2 bread-crumb-title' onClick={() => this.toggleBack()}>{`${this.props.chapterTitle || ""}`}</span>
                {/* <span className='pl-2'>{this.props.selectedElo?.conceptTitle} {`>`} </span>
                <span className='active pl-2'>{this.props.selectedElo?.title}</span> */}
            </div>
        )
    }

    showLearningOutcomeVideoAssignModal(concept, eloDetail, introContent) {

        console.log(concept, eloDetail, introContent)


        this.setState({
            showAssignVideoModal: true,
            chapterKey: concept.chapterKey,
            chapterTitle: concept.chapterTitle,
            conceptKey: concept.conceptKey ? concept.conceptKey : null,
            conceptTitle: introContent ? "Chapter Introduction Video" : concept.title,
            contentDisplayTitle: eloDetail.displayTitle,
            contentId: eloDetail._id,
            contentFrom: 'VIDEO_LIBRARY'
        })
    }

    hideAssignVideoModal = () => {
        this.setState({ showAssignVideoModal: false })
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 5000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }



    renderSolvedExamples() {

        let serialNumber = 0

        // console.log(this.state.conceptsInfo)

        return (
            <div className="row align-items-center justify-content-center mt-5">

                {
                    this.state.chapterIntroductionVideo.length ? this.state.chapterIntroductionVideo.map((introVideoContent, IntroIndex) => (
                        <div id={introVideoContent._id} className='col-md-4 flex-wrap video-learning-content-wrapper-header mb-3 position-relative' onMouseEnter={ReactTooltip.rebuild}>
                            {/* <img className='blue-dimond-icon' src={getImageSource(ImageConstants.BLUE_DIMOND_ICON)} /> */}
                            <div className='d-flex video-learning-content position-relative flex-column'>
                                <div className="">
                                    <div className='d-flex align-items-start video-learning-content-title cursor-pointer'
                                        onClick={() => this.showVideoDetail(introVideoContent, introVideoContent, 0, IntroIndex, true)} >
                                        {/* <div className='col-2 mr-1 d-flex justify-content-center align-items-center sr-no-bg '>
                                            <div className=' sr-no-bg-color'>{`${serialNumber += 1}`}</div>
                                        </div> */}
                                        <div className='align-self-center sr-no'>{`${introVideoContent.displayTitle.length > 38 ? introVideoContent.displayTitle.slice(0, 38) + "..." : introVideoContent.displayTitle}`} </div>
                                    </div>
                                </div>
                                <div className="">
                                    <img className="video-poster-image-size cursor-pointer"
                                        onClick={() => this.showVideoDetail(introVideoContent, introVideoContent, 0, IntroIndex, true)}
                                        src={getImageSource(ImageConstants.VIDEO_POSTER)} />
                                    {/* <CwContentViewer from={'video_only'}
                                        content={introVideoContent.content.description}
                                        progress={e => this.progress(e)}
                                        
                                        updateTimePlayed={(videoRef, videoPositionIndexInDescription) => this.updateTimePlayed(videoRef, videoPositionIndexInDescription, IntroIndex)}
                                        videoEnded={() => this.videoEnded(introVideoContent.chapterKey, introVideoContent.chapterTitle, introVideoContent, "CHAPTER_INTRODUCTION_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")} /> */}
                                </div>
                                <div className="row mt-2 chapter-info-wrapper" >
                                    <div className="d-flex col cursor-pointer" onClick={() => this.showVideoDetail(introVideoContent, introVideoContent, 0, IntroIndex, true)}>
                                        <div><img className="chapter-image-icon" src={introVideoContent.chapterImageUrl} /></div>
                                        <div className="ml-2 d-flex flex-column">
                                            <div><span className="chapter-title">{introVideoContent.chapterTitle}</span> | {introVideoContent.class}</div>
                                            <div>{"Chapter Introduction Video"}</div>
                                        </div>
                                    </div>
                                    <div className="col-2 p-0 share-icon-wrapper">
                                        <img className="share-icon cursor-pointer" src={getImageSource(ImageConstants.SHARE_ICON_BLACK)}
                                            data-tip={"Share Video"}
                                            onClick={() => this.showLearningOutcomeVideoAssignModal(introVideoContent, introVideoContent, true)}
                                        />
                                    </div>
                                </div>

                            </div>

                        </div>
                    ))
                        : <></>
                }


                {this.state.conceptsInfo && this.state.conceptsInfo.length && this.state.conceptsInfo.map((concept, conceptIndex) => (
                    <>

                        {concept.conceptWiseVideoLearningContent && concept?.conceptWiseVideoLearningContent?.length ?
                            concept?.conceptWiseVideoLearningContent?.map((videoContent, index) => (
                                <div id={videoContent._id} className='col-4 mb-3 video-learning-content-wrapper-header position-relative' onMouseEnter={ReactTooltip.rebuild}>
                                    {/* <img className='blue-dimond-icon' src={getImageSource(ImageConstants.BLUE_DIMOND_ICON)} /> */}

                                    <div className='d-flex video-learning-content flex-column position-relative' >

                                        <div className=" cursor-pointer" onClick={() => this.showVideoDetail(concept, videoContent, conceptIndex, index)}>
                                            <div className={`d-flex align-items-start  
                                            video-learning-content-title`}>
                                                {/* <div className='col-2 mr-2 d-flex justify-content-center align-items-center sr-no-bg '>
                                                <div className=' sr-no-bg-color'>{`${serialNumber += 1}`}</div>
                                            </div> */}
                                                <div className={`col align-self-center sr-no`}>{`${videoContent.displayTitle.length > 38 ? videoContent.displayTitle.slice(0, 38) + "..." : videoContent.displayTitle}`}</div>
                                            </div>

                                        </div>
                                        <div className=" text-right d-flex flex-row">
                                            <img className="video-poster-image-size cursor-pointer"
                                                onClick={() => this.showVideoDetail(concept, videoContent, conceptIndex, index)}
                                                src={getImageSource(ImageConstants.VIDEO_POSTER)} />
                                            {/* <CwContentViewer from={'video_only'} 
                                            showOnlyOneVideo={true}
                                            content={videoContent.content.description}
                                            videoEnded={() => this.videoEnded(this.props.chapterKey, videoContent.displayTitle, videoContent, "ELO_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")} /> */}
                                        </div>
                                        <div className="row mt-2 chapter-info-wrapper align-items-center"  >
                                            <div className="d-flex col cursor-pointer" onClick={() => this.showVideoDetail(concept, videoContent, conceptIndex, index)}>
                                                <div><img className="chapter-image-icon" src={concept.chapterImageUrl} /></div>
                                                <div className="ml-2 d-flex flex-column">
                                                    <div><span className="chapter-title">{concept.chapterTitle}</span> | {concept.class}</div>
                                                    <div>{concept.title}</div>
                                                </div>
                                            </div>
                                            <div className="col-2 p-0 share-icon-wrapper">
                                                <img className="share-icon cursor-pointer" src={getImageSource(ImageConstants.SHARE_ICON_BLACK)}
                                                    data-tip={"Share Video"}
                                                    onClick={() => this.showLearningOutcomeVideoAssignModal(concept, videoContent)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div >
                            )) : this.state.selectedConceptInfo.length ?
                                <div>
                                    <div className='d-flex justify-content-center pb-2'>No Video Content Found for {`${concept.title}`}</div>
                                    {/* <div className='divider'></div> */}
                                </div>
                                : ''

                        }
                    </>
                ))
                }
            </div>
        )

    }

    assignVideoModal = () => {
        return (
            <Modal className="cw-custom-modal-for-video-assignment" isOpen={true} toggle={this.hideAssignVideoModal} size={'lg'}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img alt="" className="close-icon cursor-pointer" onClick={this.hideAssignVideoModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center">
                        <span>Share the Video on Whatsapp</span>
                    </div>
                    <NotificationModel type={"WHATSAPP"}
                        onOk={this.onSentNotification}
                        classes={this.state.classes}
                        boards={this.state.boards}
                        selectedEloVideoDetails={null}
                        contentId={this.state.contentId}
                        contentFrom={this.state.contentFrom ? this.state.contentFrom : ''}
                        chapterTitle={this.state.chapterTitle}
                        chapterKey={this.state.chapterKey}
                        conceptTitle={this.state.conceptTitle}
                        conceptKey={this.state.conceptKey}
                        contentDisplayTitle={this.state.contentDisplayTitle}
                        hideAssignVideoModal={() => this.hideAssignVideoModal()}
                        showToaster={(type, msg) => this.showToaster(type, msg)} />
                </ModalBody>
            </Modal>
        )
    }



    render() {


        if (this.state.showVideoDetail) {
            return <VideoDetail
                videoInfo={this.state.videoInfo}
                classes={this.state.classes}
                boards={this.state.boards}
                back={() => this.hideVideoDetailScreen()} />
        }


        return (
            <div className="all-video-list">
                {/* <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div> */}
                <div className="">
                    <div className='row align-items-center heading-wrapper mt-2 p-2'>
                        {/* <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_BG)} /> */}
                        <div className='col-5 d-flex align-items-center'>
                            <div>
                                <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.PLAY_ICON_ORANGE)} />
                            </div>
                            <div>
                                <div className="header-text">{`Video Library`}</div>
                                {/* <div className=''>{this.renderBreadcrumb()}</div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4 mb-4 position-relative" onMouseEnter={ReactTooltip.rebuild}>
                    {/* {
                        this.state.selectedClass ? <img className="search-icon-size cursor-pointer" src={getImageSource(ImageConstants.SEARCH_ICON)}
                            onClick={() => this.onFilterGo()}
                            data-tip={"Search"} />
                            :
                            <></>
                    } */}

                    {/* {
                        this.state.boardsDropdownItems.length > 1 ?
                            <div className="col-2">
                                <div className="filter-input-label">
                                    Board
                                </div>
                                <div>
                                    <Dropdown
                                        placeholder='Select a board'
                                        options={this.state.boardsDropdownItems}
                                        onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                        text={"title"}
                                        value={this.state.selectedBoard}
                                    />
                                </div>
                            </div>
                            : ""
                    } */}


                    <div className="col-lg-3 col-md-6 col-sm-12">
                        {/* <div className="filter-input-label">
                            Class
                        </div> */}
                        {
                            !this.state.reloadDropdown ? <div>
                                <Dropdown
                                    placeholder='Select a Class'
                                    options={this.state.classDropdownItems}
                                    onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                    text={"title"}
                                    value={this.state.selectedClass}
                                />
                            </div> : <></>
                        }

                    </div>

                    <div className="col">
                        <div>
                            <input className={`cw-input-for-search`}
                                // disabled={this.state.selectedClass ? false : true}
                                value={this.state.search}
                                onChange={(event) => this.onChangeHandler(event, "search")}
                                placeholder='Search' />
                            {
                                this.state.showDropdown ?
                                    <div className="p-2 dropdown-scroll">
                                        {this.state.dropDownList.length ?
                                            this.state.dropDownList.map(dropdown => (
                                                <div className="dropdown-list cursor-pointer px-3 py-1" onClick={() => { this.onSelectCode(dropdown) }}>
                                                    <div className="row country-name cursor-pointer">
                                                        <div className="col pl-2"> {dropdown.displayTitle}</div>
                                                        {/* <div className="col text-right">  {dropdown.text}</div> */}
                                                    </div>
                                                </div>

                                            ))
                                            : <div className="text-center py-4 no-data">
                                                <label> No Records found</label>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <></>
                            }

                        </div>

                    </div>

                    <div className="col-1">
                        {this.state.showActiveFilter ?
                            <img className="filter-icon-new-size cursor-pointer mt-0"
                                onClick={this.showAssessmentFilterModal}
                                src={getImageSource(ImageConstants.FILTER_ICON_ACTIVE)} />
                            :
                            <img className="filter-icon-new-size cursor-pointer"
                                onClick={this.showAssessmentFilterModal}
                                src={getImageSource(ImageConstants.FILTER_ICON_NEW)} />
                        }

                    </div>

                    <div className="col-1 clear-button-wrapper ml-3">
                        <div className="filter-button  d-inline-block">
                            <button className={`cw-button clear-btn`} onClick={() => this.clearFilter()} >{"CLEAR"}</button>
                        </div>
                    </div>

                </div>

                {
                    !this.state.isLoading ?
                        <div className="solved-examples-card mt-4">

                            {
                                this.state.conceptsInfo && this.state.conceptsInfo?.length ? this.renderSolvedExamples()
                                    :
                                    // <div className='d-flex justify-content-center pb-4'>No Video Content Found for this Chapter</div>
                                    <Loading />
                                // <></>
                            }

                        </div>
                        :
                        <Loading />
                }

                {
                    <div className='card-footer' style={{ backgroundColor: "transparent" }}>
                        {
                            this.state.meta?.totalPages ?
                                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                        }
                    </div>
                }
                {
                    this.state.showAssessmentFilterModal ?
                        <ChapterListFilter
                            filter={this.state.orginalChapterList}
                            close={this.hideAssessmentFilterModal}
                            onSelect={this.onSelect} chapters={this.state.chapters}
                            selectedFilters={this.selectedFilters} delegate={this}
                            masterDataHash={this.state.masterDataHash}
                            selectedMasterDataId={this.state.selectedMasterDataId}
                            selectedBoard={this.state.selectedBoard ? "CBSE" : "CBSE"} />
                        : <></>
                }


                {this.state.showAssignVideoModal ? this.assignVideoModal() : ''}

                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}


                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        )
    }

}

export default VideoList;